import type { StatusTone } from "@/components/status-badge"

import type {
  LoadDerivedStatus,
  UsinageStatus,
} from "@/features/mill-floor/api/types"

export function loadDerivedTone(status: LoadDerivedStatus): StatusTone {
  switch (status) {
    case "available":
      return "success"
    case "assigned":
      return "warning"
    case "consumed":
      return "muted"
  }
}

export function usinageTone(status: UsinageStatus): StatusTone {
  switch (status) {
    case "COMPLETED":
      return "success"
    case "PENDING_COUPLING":
    case "COUPLAGE_PLANNED":
    case "FABRICATION":
      return "warning"
    case "RUNNING":
    case "SCHEDULED":
      return "info"
  }
}

export function usinageStatusLabelKey(status: UsinageStatus): string {
  // Operator UX collapses pre-completed states. Completed gets its own
  // label; everything else is shown as "Running" on aggregate lists
  // (the detail page surfaces the precise sub-status itself).
  if (status === "COMPLETED") return "detail.runStatus.Completed"
  return "detail.runStatus.Running"
}
